export default "__VITE_ASSET__CpVkIXvn__"